import SignupPage from '@/account/SignupPage';
import LoginPage from '@/account/LoginPage';
import ForgotPasswordPage from '@/account/ForgotPasswordPage';
import AccountPage from '@/account/AccountPage';
import TermsOfService from '@/account/TermsOfService';

import DashboardPage from '@/dashboard/DashboardPage';

import DraftPage from '@/draft/DraftPage';

import CreateDraftPage from '@/setup/CreateDraftPage';
import DraftSettingsPage from '@/setup/settings/DraftSettingsPage';
import DraftInvitePage from '@/setup/DraftInvitePage';

import DraftRoomPage from '@/draft/DraftRoomPage';
import DraftReviewPage from '@/draft/DraftReviewPage';

export default [
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: {
      noAuth: true,
    },
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignupPage,
    meta: {
      noAuth: true,
    },
  },
  {
    path: '/handleLogin',
  },
  {
    path: '/home',
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: ForgotPasswordPage,
    meta: {
      noAuth: true,
    },
  },
  {
    path: '/tos',
    name: 'tos',
    component: TermsOfService,
    meta: {
      noAuth: true,
      allowAuth: true,
    },
  },
  {
    path: '/account',
    name: 'account',
    component: AccountPage,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardPage,
  },
  {
    path: '/draft/create',
    name: 'draft.create',
    component: CreateDraftPage,
  },
  {
    path: '/invite',
    name: 'invite',
    component: DraftInvitePage,
  },
  {
    path: '/draft/:id',
    component: DraftPage,
    redirect: '/draft/:id/settings',
    children: [
      {
        path: 'settings',
        name: 'draft.settings',
        component: DraftSettingsPage,
      },
      {
        path: 'room',
        name: 'draft.room',
        component: DraftRoomPage,
        meta: {
          fullScreen: true,
        },
      },
      {
        path: 'review',
        name: 'draft.review',
        component: DraftReviewPage,
        meta: {
          fullScreen: true,
          noAuth: true,
          allowAuth: true,
        },
      },
    ],
  },
  {
    path: '*',
    redirect: '/dashboard',
  },
];
